import {
  GetAccessiblePortfolioContentsBreakdownResponse,
  GetAccessiblePortfoliosResponse,
} from '@upright/common/iam/organizations/organization-types';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { GetFundScreenerResultsResponse } from '../../../../../common/model/search/fund-screener/api-types';
import { optionsToString } from '@upright/ui/api/common/util';
import { GetPortfolioSearchSuggestionsResponse } from '@upright/common/iam/access/api-types';

export async function getAccessiblePortfolios(release: string) {
  return await fetchOrThrow<GetAccessiblePortfoliosResponse>(`/scores/${release}/portfolio-infos`);
}

export async function getAccessiblePortfolioContentsBreakdown(
  release: string,
  type: 'portfolios' | 'company-groups' | 'companies',
) {
  return await fetchOrThrow<GetAccessiblePortfolioContentsBreakdownResponse>(
    `/scores/${release}/portfolio-content-breakdown/${type}`,
  );
}

export async function getPortfolioSearchSuggestions() {
  return await fetchOrThrow<GetPortfolioSearchSuggestionsResponse>(`/access/few-portfolios`);
}

export async function getAccessiblePortfolioContentsFundsBreakdown(
  release: string,
  offset?: number,
  limit?: number,
  sortBy?: { column: string; direction: 'ASC' | 'DESC' },
) {
  const params = {
    offset,
    limit,
    sortBy: sortBy && JSON.stringify(sortBy),
  };
  return await fetchOrThrow<GetFundScreenerResultsResponse>(
    `/scores/${release}/portfolio-content-breakdown/funds${optionsToString(params)}`,
    'GET',
  );
}
